<template>
    <group-details :groupId="props.groupId">
        <segment-list :groupId="props.groupId" readOnly withoutOverview embedded></segment-list>
    </group-details>
</template>

<script setup>
import GroupDetails from './GroupDetails.vue';
import SegmentList from '~/components/contacts/segments/SegmentList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: false,
    },
});

</script>
